import Vue from 'vue'
import VueRouter from 'vue-router'
import { auth } from '@/shared/firebase'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/shelf/:shelfSpaceId',
    name: 'shelf',
    meta: {
      backLink: '/'
    },
    component: () => import('@/views/Shelf.vue')
  },
  {
    path: '/product/:productId',
    name: 'product',
    component: () => import('@/views/Product.vue')
  },
  {
    path: '/expiring-items',
    name: 'expiringitems',
    component: () => import('@/views/ExpiringItems.vue')
  },
  {
    path: '/purchase/:purchaseSource?',
    name: 'purchase',
    component: () => import('@/views/Purchase.vue')
  },
  {
    path: '/missingproducts',
    name: 'missingProducts',
    component: () => import('@/views/MissingProducts.vue')
  },
  {
    path: '/orders',
    name: 'ordersOverview',
    component: () => import('@/views/Order/Orders.vue'),
    meta: {
      backLink: '/'
    }
  },
  {
    path: '/orders/:orderId',
    name: 'orderDetail',
    component: () => import('@/views/Order/Order.vue'),
    meta: {
      backLink: '/orders'
    }
  },
  {
    path: '/orders/:orderId/pack/:type/:residentIndex?',
    name: 'orderPack',
    component: () => import('@/views/Order/Pack.vue')
  },
  {
    path: '/materialshipments',
    name: 'materialShipments',
    component: () => import('@/views/MaterialShipments.vue'),
    meta: {
      backLink: '/'
    }
  },
  {
    path: '/materialshipments/:shipmentId',
    name: 'materialShipment',
    component: () => import('@/views/MaterialShipment.vue'),
    meta: {
      backLink: '/materialshipments'
    }
  },
  {
    path: '/shipments',
    name: 'shipments',
    component: () => import('@/views/Shipments.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !auth.currentUser) next('login')
  else {
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next()
  }
})

export default router
